import { Schema } from 'effect';
import { LaunchpadIdSchema } from './launchpad';
import { OrderSchema } from './order';

export const PackageIdSchema = Schema.Number;
export type PackageId = Schema.Schema.Type<typeof PackageIdSchema>;

/**
 * The package to be delivered.
 */
export const PackageSchema = Schema.transform(
  Schema.Struct({
    id: PackageIdSchema,
    creation_timestamp: Schema.String,
    name: Schema.String,
    weight_kg: Schema.Number,
    order: Schema.encodedSchema(OrderSchema),
    is_refly: Schema.Boolean,
    preferred_launchpad_id: Schema.optional(Schema.NullOr(LaunchpadIdSchema))
  }),
  Schema.Struct({
    id: PackageIdSchema,
    creationTimestamp: Schema.String,
    name: Schema.String,
    weightKg: Schema.Number,
    order: OrderSchema,
    isRefly: Schema.Boolean,
    preferredLaunchpadId: Schema.optional(Schema.NullOr(LaunchpadIdSchema))
  }),
  {
    strict: true,
    decode: (api) => ({
      id: api.id,
      creationTimestamp: api.creation_timestamp,
      name: api.name,
      weightKg: api.weight_kg,
      order: api.order,
      isRefly: api.is_refly,
      preferredLaunchpadId: api.preferred_launchpad_id
    }),
    encode: (client) => ({
      id: client.id,
      creation_timestamp: client.creationTimestamp,
      name: client.name,
      weight_kg: client.weightKg,
      order: client.order,
      is_refly: client.isRefly,
      preferred_launchpad_id: client.preferredLaunchpadId
    })
  }
);
export type Package = Schema.Schema.Type<typeof PackageSchema>;
